module.exports = __webpack_public_path__ + "static/images/questionMark.163206a7355f03f72757495b7e494dc0.svg";